import { Box } from '@spark-web/box';
import { Columns } from '@spark-web/columns';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { DataListItem } from './types';

function Item({ symbol, label, value, valueOverflowStrategy = 'breakword', description }: DataListItem) {
  return (
    <Box>
      <Box gap="large" display="flex" flexDirection="row" justifyContent="spaceBetween">
        <Text tone="muted">
          <>
            {label}
            {symbol ? <sup>{symbol}</sup> : null}
          </>
        </Text>
        {value ? (
          <Text weight="semibold" align="right" overflowStrategy={valueOverflowStrategy}>
            {value}
          </Text>
        ) : null}
      </Box>

      {description ? (
        <Box paddingTop="small">
          <Text>({description})</Text>{' '}
        </Box>
      ) : null}
    </Box>
  );
}

interface Props {
  title?: string;
  items?: DataListItem[];
}

function DataList({ title, items }: Props) {
  return (
    <Stack gap="large" padding="medium" paddingY="medium">
      {title ? (
        <Columns paddingBottom="small">
          <Heading level="3">{title}</Heading>
        </Columns>
      ) : null}
      {items?.map((item, index) => (
        <Item key={`${item.label}-${index}`} {...item} />
      ))}
    </Stack>
  );
}

export default DataList;
